import axios from "../axios";

export const supplierProductsApi = {
  list: (params) => axios.get("/inventory/supplier_products", {
    params: typeof params === "object" ? params : { product_id: params },
  }),
  create: (data) => axios.post("/inventory/supplier_products", { supplier_product: data }),
  update: (id, data) => axios.put(`/inventory/supplier_products/${id}`, { supplier_product: data }),
};
